import { Component, OnInit } from '@angular/core';
import { MessageService } from '../../util/message.service';
import { MessageConfig } from '../../models/messageConfig';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss']
})


export class MessageComponent implements OnInit {
  visible: boolean = false
  msg: string = ''
  color = 'green'

  constructor(
    private _messageService: MessageService
  ) { }

  ngOnInit() {
    this._messageService.message$.subscribe((config: MessageConfig) => {
      this.visible = config.visible
      this.color = config.color
      this.msg = config.msg
      setTimeout(() => {
        this.visible = false
      }, 8000);
    })
  }

}
